// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__nlNuq","select":"Header_select__2V-wv","clinic":"Header_clinic__xBz6Z"};